// ---------------------------------------------------------------
// SinAcceso.js — Lo que ve quien tiene cuenta pero no acceso.
//
// Le pasa a tres tipos de persona: a quien se eliminó (su cuenta de
// acceso sigue existiendo, pero ya no tiene ficha), a quien se dio de
// baja, y a quien entró con Google sin ser de la farmacia. A ninguno
// le dice cuál es su caso: no hace falta, y a un desconocido no hay
// por qué confirmarle nada sobre la plantilla.
// ---------------------------------------------------------------
import { cerrarSesion } from "../services/authService";

export default function SinAcceso({ email }) {
  return (
    <div className="auth-screen">
      <div className="auth-card sin-acceso">
        <img
          src={`${process.env.PUBLIC_URL}/logo.png`}
          alt="Farmacia Buendía"
          className="auth-logo-img"
        />
        <h1 className="auth-title">Sin acceso al portal</h1>
        <p className="sin-acceso-texto">
          La cuenta <strong>{email}</strong> no tiene acceso al portal de la
          Farmacia Buendía.
        </p>
        <p className="sin-acceso-texto pequeno">
          Si trabajas en la farmacia y crees que es un error, habla con la
          dirección.
        </p>
        <button className="auth-submit" onClick={cerrarSesion}>
          Salir
        </button>
      </div>
    </div>
  );
}
